import { httpGet, httpPost } from '../../../../../utils/api.utils';
import { CIRCUIT_CATEGORIES as CircuitCategory, EQUIPMENT_TYPE as EquipmentType, TRANSLATIONS } from '../../../../../utils/constant.utils';
import { ERROR_TYPE } from '../../../../../constants/external-constants'; 
import { getRequestUserSessionData as getUserData } from '../../../../../utils/helpers.utils';
import { updatePlanTypesByCircuitType, getVendorDetails, getAddresses, addZeroes } from '../../order-request.functions';

import { actions } from 'react-redux-form';

import {
    portInLocationModelA
    , portInSubscriptionModelA
    , portInBusinessModelA

    //ACTIONS
    , setUserLocation
    , setCountryOptions
    , setAddressOptions
    , setPlanOptions
    , setVendorOptions
    , setSimOptions
    , setVendorDetails
    , setServiceTypeDetails
    , setDeviceOptions
    , setOrderOptions
    , setDeviceAccessories
    , setPrimaryPlanDetails
    , setPurposeOfUseOptions
    , setBusinessCaseOptions
    , setShowDeviceOptions
    , setShowOtherAddress
    , setFormSubmitted
    , setFormSubmitting
    , setLoading
    , getCircuitTypes
    , getMobileServiceTypes
    , getVendors
    , getPlanComponent
    , getOrderRequestForm
    , setMobileError
} from './../../../../../constants/model-reducers/external/request/wireless-request/wireless-port-in.settings';

export const portInLocationModelAInitialState = portInLocationModelA;
export const portInSubscriptionModelAInitialState = portInSubscriptionModelA;
export const portInBusinessModelAInitialState = portInBusinessModelA;

const planDetailConst = {
    PlanId: 0
    , ComponentName: ''
    , ComponentCost: 0
    , ComponentDetails: ''
    , IsPrimary: true
}

const serviceTypeDetailConst = {
    EquipmentInventoryId: 0
    , OrderCost: 0
}

const defaultState = () => ({
    userLocation: {}
    , countryOptions: []
    , addressOptions: []
    , simOptions: []
    , preferredVendorOptions: []
    , nonPrefVendorOptions: []
    , planOptions: []
    , orderOptions: []
    , deviceOptions: []
    , deviceAccessories: []
    , vendorDetails: {
        Currency: ''
    }
    , serviceTypeDetail: { ...serviceTypeDetailConst }
    , primaryPlanDetail: { ...planDetailConst }
    , purposeOfUseOptions: []
    , businessCaseOptions: []
    , showDeviceOptions: false
    , showOtherAddress: false
    , formSubmitted: false
    , isLoading: false
    , circuitTypeOptions: []
    , mobileServiceTypeOptions: []
    , plansDatatable: []
    , totalOrderCost: 0
    , orderRequest: {
        Addresses: [{ id: '', value: '' }],
        LocationOrderModel: {},
        User: {},
        Currency: '',
        SubscriptionModel: {},
        BusinessJustificationModel: {
            IsTaxable: false
        },
        WirelineSubscriptionModel: {}
    }
    , formSubmitting: false
    , loadingSubscriptionForm: false
    , vendorOptions: []
});

const initialState = defaultState();

export const wirelessPortInActions = {
    getNewPortInFormData: (orderId) => async (dispatch, state) => {
        const { requestTypeId } = state().createRequest;

        var data = {
            RequestTypeId: requestTypeId
            , User: { ...getUserData() }
        };

        dispatch({
            type: setLoading,
            isLoading: true
        });

        var res = await httpPost('external/orderRequest/getOrderForm', data);

        if (res != null) {
            dispatch(actions.change('wirelessPortInLocationFormA.country', 'USA'));
            getAddresses(dispatch, setAddressOptions, 'US');

            dispatch({ type: setUserLocation, data: res.UserLocation });
            dispatch({ type: setCountryOptions, data: res.Countries });
            dispatch({ type: setPurposeOfUseOptions, data: res.PurposeOfUse });
            dispatch({ type: setBusinessCaseOptions, data: res.BusinessJustification });
            dispatch({ type: setShowOtherAddress, data: res.ShowOtherAddress ?? res.NewMobileLocationFormClient });

            if (res.Countries?.length == 1) {
                dispatch(actions.change('wirelessPortInLocationFormA.countryCode', res.Countries[0].Key));
            }

            dispatch({
                type: getOrderRequestForm,
                orderRequest: res
            });
        }

        if (orderId) {
            const { requestData } = state().requestDetail;

            dispatch(actions.change('wirelessPortInLocationFormA.country', requestData.BillingAddress.CountryName));
            dispatch(actions.change("wirelessPortInLocationFormA.countryCode", requestData.BillingAddress.CountryCode));
            dispatch(actions.change("wirelessPortInLocationFormA.locationId", requestData.BillingAddress.LocationId));
            dispatch(actions.change("wirelessPortInLocationFormA.deliveryAddress", requestData.BillingAddress.DeliveryAddress));
            dispatch(actions.change("wirelessPortInLocationFormA.otherDeliveryAddress", requestData.BillingAddress.OtherDeliveryAddress));
            dispatch(actions.change("wirelessPortInLocationFormA.otherDeliveryAddressId", requestData.BillingAddress.OtherDeliveryAddressId));

            dispatch(actions.change("wirelessPortInSubscriptionFormA.personalMobile", requestData.Subscription.PersonalMobile));
            dispatch(actions.change("wirelessPortInSubscriptionFormA.currentVendor", requestData.Subscription.CurrentVendor));
            dispatch(actions.change("wirelessPortInSubscriptionFormA.accountNumber", requestData.Subscription.AccountNumber));
            dispatch(actions.change("wirelessPortInSubscriptionFormA.portPinCode", requestData.Subscription.PortPinCode));
            dispatch(actions.change("wirelessPortInSubscriptionFormA.currentBillingAddress", requestData.Subscription.CurrentBillingAddress));
            dispatch(actions.change("wirelessPortInSubscriptionFormA.vendorDetailId", requestData.Subscription.VendorDetailId));
            dispatch(actions.change("wirelessPortInSubscriptionFormA.circuitTypeId", requestData.Subscription.CircuitTypeId));
            dispatch(actions.change("wirelessPortInSubscriptionFormA.equipmentInventoryId", requestData.Subscription.EquipmentInventoryId));
            dispatch(actions.change("wirelessPortInSubscriptionFormA.phoneCaseAccessory", requestData.Subscription.PhoneCaseAccessory));
            dispatch(actions.change("wirelessPortInSubscriptionFormA.planId", requestData.Subscription.PlanId));

            dispatch(actions.change("wirelessPortInBusinessFormA.purposeOfUseId", requestData.BusinessJustification.PurposeOfUseId));
            dispatch(actions.change("wirelessPortInBusinessFormA.busJustiCodeDetailId", requestData.BusinessJustification.BusJustiCodeDetailId));
            dispatch(actions.change("wirelessPortInBusinessFormA.businessJustification", requestData.BusinessJustification.BusinessJustification));
            dispatch(actions.change("wirelessPortInBusinessFormA.additionalInformation", requestData.BusinessJustification.AdditionalInformation));
            dispatch(actions.change("wirelessPortInBusinessFormA.termAgreement", requestData.BusinessJustification.TermAgreement));

            const { showOtherAddress } = state().wirelessPortInRequest;
            await getAddresses(dispatch, setAddressOptions, requestData.Location.CountryCode, showOtherAddress);
        }

        dispatch({
            type: setLoading,
            isLoading: false
        });
    }
    , setRequestorAddress: () => (dispatch, state) => {

        const { showOtherAddress, userLocation } = state().wirelessPortInRequest;
        const { requestOnBehalfData } = state().createRequest;

        var location = {
            ...userLocation
        };

        if (requestOnBehalfData.EmployeeId > 0) {
            location = {
                ...requestOnBehalfData.LocationModel
            };
        }

        getAddresses(dispatch, setAddressOptions, location.CountryCode, showOtherAddress);

        dispatch(actions.change('wirelessPortInLocationFormA.country', location.CountryName));
        dispatch(actions.change('wirelessPortInLocationFormA.countryCode', location.CountryCode));
        dispatch(actions.change('wirelessPortInLocationFormA.locationId', location.LocationId));
        dispatch(actions.change('wirelessPortInLocationFormA.deliveryAddress', location.DeliveryAddress));
        dispatch(actions.change('wirelessPortInLocationFormA.otherDeliveryAddress', ''));

    }
    , onAddressSelect: (model, value) => async (dispatch, state) => {

        const { addressOptions } = state().wirelessPortInRequest;

        dispatch(actions.change(model, value));

        const deliveryAddress = addressOptions.length > 0 ? addressOptions.find(r => r.Key == value).Value : '';

        dispatch(actions.change('wirelessPortInLocationFormA.deliveryAddress', deliveryAddress));
        dispatch(actions.change('wirelessPortInLocationFormA.otherDeliveryAddress', ''));

    }
    , onCountrySelect: (model, value) => async (dispatch, state) => {

        const { countryOptions, showOtherAddress } = state().wirelessPortInRequest;

        dispatch(actions.change(model, value));

        let country = countryOptions.find(o => o['Key'] === value).Value;
        dispatch(actions.change('wirelessPortInLocationFormA.country', country));

        dispatch(actions.change('wirelessPortInLocationFormA.locationId', ''));
        dispatch(actions.change('wirelessPortInLocationFormA.deliveryAddress', ''));
        dispatch(actions.change('wirelessPortInLocationFormA.otherDeliveryAddress', ''))
        resetSubscriptionFormOnLocationChange(dispatch);

        getAddresses(dispatch, setAddressOptions, value, showOtherAddress);

    }
    , onVendorSelect: (vendorDetailId) => async (dispatch, state) => {
        const { wirelessPortInSubscriptionFormA } = state().form;
        const { isRequestOnBehalf, requestOnBehalfData } = state().createRequest;

        var userData = getUserData();
        if (isRequestOnBehalf) {
            userData.employeeID = requestOnBehalfData.EmployeeId;
        }

        dispatch(actions.change('wirelessPortInSubscriptionFormA.orderOptionId', 0));
        dispatch(actions.change('wirelessPortInSubscriptionFormA.equipmentCatalogId', 0));
        dispatch(actions.change('wirelessPortInSubscriptionFormA.mobileServiceModel', []));
        dispatch(actions.change('wirelessPortInSubscriptionFormA.accessoryDetailsModel', []));
        dispatch(actions.change('wirelessPortInSubscriptionFormA.planId', 0));
        dispatch(actions.change('wirelessPortInSubscriptionFormA.planDetailsModel', portInSubscriptionModelA.planDetailsModel));
        dispatch(actions.setErrors('wirelessPortInSubscriptionFormA.equipmentInventoryId', false));
        dispatch(actions.reset("wirelessPortInSubscriptionFormA.circuitTypeId"));
        dispatch(actions.reset("wirelessPortInSubscriptionFormA.equipmentInventoryId"));
        dispatch(actions.reset("wirelessPortInSubscriptionFormA.phoneCaseAccessory"));
        dispatch(actions.reset("wirelessPortInSubscriptionFormA.planId"));
        dispatch({ type: getPlanComponent, plansDatatable: [], totalOrderCost: 0 });
        dispatch({ type: setDeviceAccessories, data: [] });
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
        dispatch({ type: setShowDeviceOptions, data: false });
        dispatch({ type: setPrimaryPlanDetails, data: planDetailConst });
        updatePlanTypesByCircuitType(dispatch, setPlanOptions, vendorDetailId, wirelessPortInSubscriptionFormA.circuitTypeId);
        getMobileServiceTypeOptions(dispatch, vendorDetailId, wirelessPortInSubscriptionFormA.circuitTypeId, userData.employeeID);
        getVendorDetails(dispatch, setVendorDetails, defaultState.vendorDetails, vendorDetailId)
    }
    , onCircuitTypeSelect: (circuitTypeId) => async (dispatch, state) => {
        const { wirelessPortInSubscriptionFormA } = state().form;
        const { isRequestOnBehalf, requestOnBehalfData } = state().createRequest;

        var userData = getUserData();
        if (isRequestOnBehalf) {
            userData.employeeID = requestOnBehalfData.EmployeeId;
        }

        updatePlanTypesByCircuitType(dispatch, setPlanOptions, wirelessPortInSubscriptionFormA.vendorDetailId, circuitTypeId);
        getMobileServiceTypeOptions(dispatch, wirelessPortInSubscriptionFormA.vendorDetailId, circuitTypeId, userData.employeeID);
        dispatch(actions.setErrors("wirelessPortInSubscriptionFormA.equipmentInventoryId", false));
        dispatch(actions.change('wirelessPortInSubscriptionFormA.equipmentCatalogId', 0));
        dispatch(actions.change('wirelessPortInSubscriptionFormA.mobileServiceModel', []));
        dispatch(actions.change('wirelessPortInSubscriptionFormA.accessoryDetailsModel', []));
        dispatch(actions.change('wirelessPortInSubscriptionFormA.planId', 0));
        dispatch(actions.change('wirelessPortInSubscriptionFormA.planDetailsModel', portInSubscriptionModelA.planDetailsModel));
        dispatch(actions.setErrors('wirelessPortInSubscriptionFormA.equipmentInventoryId', false));
        dispatch(actions.reset("wirelessPortInSubscriptionFormA.circuitTypeId"));
        dispatch(actions.reset("wirelessPortInSubscriptionFormA.equipmentInventoryId"));
        dispatch(actions.reset("wirelessPortInSubscriptionFormA.phoneCaseAccessory"));
        dispatch(actions.reset("wirelessPortInSubscriptionFormA.planId"));
        dispatch({ type: getPlanComponent, plansDatatable: [], totalOrderCost: 0 });
        dispatch({ type: setDeviceAccessories, data: [] });
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
        dispatch({ type: setShowDeviceOptions, data: false });
        dispatch({ type: setPrimaryPlanDetails, data: planDetailConst });
    }
    , onOrderSelect: (model, value) => async (dispatch, state) => {

        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelessPortInSubscriptionFormA.equipmentCatalogId', 0));
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });

        const isAccessory = value == EquipmentType.Accessory;
        dispatch({ type: setShowDeviceOptions, data: isAccessory });

        if (isAccessory) {

            const { wirelessPortInSubscriptionFormA } = state().form;
            const { requestOnBehalfData } = state().createRequest;
            var employeeId = requestOnBehalfData.EmployeeId > 0 ? requestOnBehalfData.EmployeeId : sessionStorage.getItem('EmployeeID');
            getDeviceAccessories(dispatch, wirelessPortInSubscriptionFormA.vendorDetailId, employeeId);
        }

    }
    , onServiceTypeSelect: (model, value, orderId) => async (dispatch, state) => {
        const { requestOnBehalfData } = state().createRequest;
        const { mobileServiceTypeOptions } = state().wirelessPortInRequest;

        dispatch(actions.change('wirelessPortInSubscriptionFormA.mobileServiceModel', []));
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
        await getServiceTypeDetails(dispatch, value);

        var mobileServiceType = mobileServiceTypeOptions.find(r => r.EquipmentInventoryId == value);
        if (mobileServiceType?.EquipmentTypeId == EquipmentType.Device) {
            var employeeId = requestOnBehalfData.EmployeeId > 0 ? requestOnBehalfData.EmployeeId ?? 0 : sessionStorage.getItem('EmployeeID');

            let locale = state().translation.locale;
            if (locale === null || locale === '')
                locale = TRANSLATIONS['defaultLocaleLanguage'];
            await validateMobileServiceType(dispatch, locale, model, employeeId, value, orderId);
        }
        else {
            dispatch(actions.setErrors(model, false));
        }
    }
    , onPlanSelect: (model, value) => async (dispatch, state) => {
        getPlanComponentByPlan(dispatch, value);
    }
    , onAccessorySelect: (e) => async (dispatch, state) => {

        const { deviceAccessories } = state().wirelessPortInRequest;
        const { wirelessPortInSubscriptionFormA } = state().form;
        var selectedObj = deviceAccessories.find(x => x.EquipmentInventoryId == e.target.value);
        var newAccessories = [...wirelessPortInSubscriptionFormA.accessoryDetailsModel];

        if (e.target.checked) {
            newAccessories.push(selectedObj);
        } else {

            const indexOfObject = wirelessPortInSubscriptionFormA.accessoryDetailsModel.findIndex(o => {
                return o.EquipmentInventoryId == e.target.value;
            });

            newAccessories.splice(indexOfObject, 1);
        }

        dispatch(actions.change('wirelessPortInSubscriptionFormA.accessoryDetailsModel', newAccessories));
    }
    , onSubscriptionFormLoad: () => async (dispatch, state) => {
        dispatch({
            type: setLoading,
            isLoading: true
        });

        await getCircuitTypesByCategory(dispatch, CircuitCategory.mobile);

        dispatch({
            type: setLoading,
            isLoading: false
        });

    }
    , resetWirelessPortInForm: () => (dispatch, state) => {
        resetWirelessPortInForm(dispatch)
    }
    , submitRequest: (orderId) => async (dispatch, state) => {
        const { plansDatatable, orderRequest } = state().wirelessPortInRequest;
        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const { wirelessPortInLocationFormA, wirelessPortInSubscriptionFormA, wirelessPortInBusinessFormA } = state().form;

        var planComponents = plansDatatable.length > 0 ? plansDatatable[0].dataItem : [];

        var subscriptionFormA = {
            ...wirelessPortInSubscriptionFormA,
            planDetails: {
                ...wirelessPortInSubscriptionFormA.planDetails,
                planComponents: planComponents
            }
        }

        let userData = getUserData();
        const requestorEmployeeID = userData.employeeID

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
            userData.employeeID = requestOnBehalfData.EmployeeId;
        }

        userData.managerApproverId = isRequestOnBehalf ?
            requestOnBehalfData.CostCodeApproverEmployeeId : sessionStorage.CostCodeAuthorizerID;

        let circuitId = 0;
        let orderInfoId = 0;
        let orderHistoryId = 0;
        let circuitOrderId = 0;
        if (orderId) {
            const { CircuitId, OrderInfoId, OrderHistoryId, CircuitOrderId } = state().requestDetail.requestData;
            circuitId = CircuitId;
            orderInfoId = OrderInfoId;
            orderHistoryId = OrderHistoryId;
            circuitOrderId = CircuitOrderId;
        }

        var data = {
            ...orderRequest,
            LocationOrderModel: { ...wirelessPortInLocationFormA }
            , SubscriptionModel: { ...subscriptionFormA, EquipmentInventory: wirelessPortInSubscriptionFormA.mobileServiceModel[0].EquipmentModel }
            , BusinessJustificationModel: { ...wirelessPortInBusinessFormA }
            , User: {
                ...userData
            }
            , NoEmail: true
            , RequestTypeId: requestTypeId
            , IsAmending: circuitId > 0 && orderId > 0
            , OrderId: orderId
            , CircuitId: circuitId
            , OrderInfoId: orderInfoId
            , OrderHistoryId: orderHistoryId
            , CircuitOrderId: circuitOrderId
            , RequestorID: Number(requestorEmployeeID)
        };

        dispatch({ type: setFormSubmitted, data: true });
        dispatch({ type: setFormSubmitting, data: true });
        var res = await httpPost('external/orderRequest', data);

        if (!(res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }
        dispatch({ type: setFormSubmitting, data: false });
        return res;
    }
    , validateMobileNumber: (model, value, orderId) => async (dispatch, state) => {

        await validateMobileNumber(dispatch, model, value, orderId);
    }
    , getVendorOptions: () => async (dispatch, state) => {
        const { wirelessPortInLocationFormA } = state().form;
        await getVendorOptions(dispatch, wirelessPortInLocationFormA.country);
    }
    , loadPortInLocationForm: (orderId) => async (dispatch, state) => {
        const { requestOnBehalfData } = state().createRequest;

        dispatch({
            type: setLoading,
            formName: "Subscription",
            isLoading: true
        });

        const { wirelessPortInLocationFormA, wirelessPortInSubscriptionFormA } = state().form;

        var employeeId = requestOnBehalfData.EmployeeId > 0 ? requestOnBehalfData.EmployeeId ?? 0 : sessionStorage.getItem('EmployeeID');

        await getVendorOptions(dispatch, wirelessPortInLocationFormA.country);
        await getCircuitTypesByCategory(dispatch, CircuitCategory.mobile);

        if (wirelessPortInSubscriptionFormA.vendorDetailId && wirelessPortInSubscriptionFormA.circuitTypeId) {
            var mobileServiceTypeOptions = await getMobileServiceTypeOptions(dispatch, wirelessPortInSubscriptionFormA.vendorDetailId, wirelessPortInSubscriptionFormA.circuitTypeId, employeeId);

            if (wirelessPortInSubscriptionFormA.equipmentInventoryId) {
                var mobileServiceType = mobileServiceTypeOptions.find(r => r.EquipmentInventoryId == wirelessPortInSubscriptionFormA.equipmentInventoryId);
                if (mobileServiceType?.EquipmentTypeId == EquipmentType.Device) {
                    let locale = state().translation.locale;
                    if (locale === null || locale === '')
                        locale = TRANSLATIONS['defaultLocaleLanguage'];

                    await validateMobileServiceType(dispatch, locale, "wirelessPortInSubscriptionFormA.equipmentInventoryId", employeeId, wirelessPortInSubscriptionFormA.equipmentInventoryId, orderId);
                }
                await getServiceTypeDetails(dispatch, wirelessPortInSubscriptionFormA.equipmentInventoryId);
            }
        }

        if (wirelessPortInSubscriptionFormA.vendorDetailId && wirelessPortInSubscriptionFormA.circuitTypeId) {
            await updatePlanTypesByCircuitType(dispatch, setPlanOptions, wirelessPortInSubscriptionFormA.vendorDetailId, wirelessPortInSubscriptionFormA.circuitTypeId);
        }

        if (wirelessPortInSubscriptionFormA.planId) {
            await getPlanComponentByPlan(dispatch, wirelessPortInSubscriptionFormA.planId);
        }

        if (wirelessPortInSubscriptionFormA.vendorDetailId) {
            getVendorDetails(dispatch, setVendorDetails, defaultState.vendorDetails, wirelessPortInSubscriptionFormA.vendorDetailId)
        }

        dispatch({
            type: setLoading,
            formName: "Subscription",
            isLoading: false
        });
    }
}

async function resetWirelessPortInForm(dispatch) {
    dispatch({
        type: getPlanComponent,
        plansDatatable: [],
        totalOrderCost: 0
    });
    var res = await httpPost('external/replaceDevice/getCountriesList');

    dispatch(actions.reset('wirelessPortInLocationFormA'));
    dispatch(actions.reset('wirelessPortInSubscriptionFormA'));
    dispatch(actions.reset('wirelessPortInBusinessFormA'));
    dispatch({ type: setFormSubmitted, data: false });

    if (res.length == 1) {
        dispatch(actions.change('wirelessPortInLocationFormA.countryCode', res[0].Key));
        dispatch(actions.change('wirelessPortInLocationFormA.country', res[0].Value));
        getAddresses(dispatch, setAddressOptions, res[0].Key);
    }
}

function resetRequestOnBehalf(dispatch) {
    dispatch(actions.change('wirelessPortInLocationFormA.locationId', ''));
    dispatch(actions.change('wirelessPortInLocationFormA.deliveryAddress', ''));
    dispatch(actions.change('wirelessPortInLocationFormA.otherDeliveryAddress', ''));
    
    resetSubscriptionFormOnLocationChange(dispatch)
}

function resetSubscriptionFormOnLocationChange(dispatch) {
    dispatch(actions.reset("wirelessPortInSubscriptionFormA.vendorDetailId"));
    dispatch(actions.reset("wirelessPortInSubscriptionFormA.circuitTypeId"));
    dispatch(actions.reset("wirelessPortInSubscriptionFormA.equipmentInventoryId"));
    dispatch(actions.reset("wirelessPortInSubscriptionFormA.phoneCaseAccessory"));
    dispatch(actions.reset("wirelessPortInSubscriptionFormA.planId"));

    dispatch({ type: setPlanOptions, data: [] });
    dispatch({ type: setVendorOptions, data: [] });
    dispatch({ type: setSimOptions, data: [] });
    dispatch({
        type: getMobileServiceTypes,
        mobileServiceTypeOptions: [],
    });
    dispatch({
        type: getVendors,
        vendorOptions: []
    });
    dispatch({
        type: getPlanComponent,
        plansDatatable: [],
        totalOrderCost: 0
    });
}

function resetSubscriptionForm(dispatch) {
    dispatch(actions.reset('wirelessPortInSubscriptionFormA'));
    dispatch({ type: setPlanOptions, data: [] });
    dispatch({ type: setVendorOptions, data: [] });
    dispatch({ type: setSimOptions, data: [] });
    dispatch({
        type: getMobileServiceTypes,
        mobileServiceTypeOptions: [],
    });
    dispatch({
        type: getVendors,
        vendorOptions: []
    });
    dispatch({
        type: getPlanComponent,
        plansDatatable: [],
        totalOrderCost: 0
    });
}

async function getDeviceAccessories(dispatch, vendorId, employeeId) {

    var res = await httpGet(`external/orderRequest/getEquipmentData/${vendorId}/${EquipmentType.Accessory}/${employeeId}`);

    if (res != null && res.length > 0) {
        dispatch({ type: setDeviceAccessories, data: res });
    } else {
        dispatch({ type: setDeviceAccessories, data: [] });
    }
}

async function getServiceTypeDetails(dispatch, typeId) {

    var res = await httpGet('external/orderRequest/getMobileServiceTypeDetails/' + typeId);

    if (res != null && res.length > 0) {
        dispatch({ type: setServiceTypeDetails, data: res[0] });
        dispatch(actions.change('wirelessPortInSubscriptionFormA.mobileServiceModel', res));
    } else {
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
        dispatch(actions.change('wirelessPortInSubscriptionFormA.mobileServiceModel', []));
    }

}

async function validateMobileNumber(dispatch, model, mobileNumber, orderId) {
    var res = await httpGet(`external/orderRequest/validateMobileNumber/${mobileNumber}/${orderId ?? 0}`);

    if (res.success && res.message) {
        dispatch(actions.setErrors(model, `Error: ${res.message}`));
        dispatch({
            type: setMobileError,
            mobileError: true
        });        
    } else {
        dispatch({
            type: setMobileError,
            mobileError: false
        });
    }
}

async function getCircuitTypesByCategory(dispatch, categoryid) {
    try {
        var res = await httpGet('external/inventory/getInventoryCircuitTypesByCategory/' + categoryid);

        dispatch({
            type: getCircuitTypes,
            circuitTypeOptions: res,
        });
    }
    catch (e) {
        dispatch({
            type: getCircuitTypes,
            circuitTypeOptions: [],
        });
    }
}

async function getMobileServiceTypeOptions(dispatch, vendorId, circuitTypeId, employeeID) {
    try {
        var res = await httpGet(`external/orderRequest/mobileServiceTypes/${vendorId}/${circuitTypeId}/${employeeID}`);

        dispatch({
            type: getMobileServiceTypes,
            mobileServiceTypeOptions: res.data,
        });

        return res.data;
    }
    catch (e) {
        dispatch({
            type: getMobileServiceTypes,
            mobileServiceTypeOptions: [],
        });

        return [];
    }
}

async function getVendorOptions(dispatch, country) {
    try {
        var res = await httpGet(`external/orderRequest/getVendorsByCountry/${country}`);

        dispatch({
            type: getVendors,
            vendorOptions: res
        });
    }
    catch (e) {
        dispatch({
            type: getVendors,
            vendorOptions: []
        });
    }
}

async function validateMobileServiceType(dispatch, locale, model, employeeId, equipmentInventoryId, orderId) {
    try {
        var res = await httpGet(`external/orderRequest/validateMobileServiceType/${employeeId}/${equipmentInventoryId}/${orderId ?? 0}`);

        var errors = {};
        if (res.messages[ERROR_TYPE.existingServiceType]) {
            errors = {
                ...errors,
                warning_existingServiceType: TRANSLATIONS[locale]["warning_existing_service_type"]
            };
        }
        if (res.messages[ERROR_TYPE.existingOpenRequestWithServiceType]) {
            errors = {
                ...errors,
                warning_existingOpenRequestWithServiceType: TRANSLATIONS[locale]["warning_open_request_service_type"]
            };
        }

        if (Object.keys(errors).length > 0) {
            dispatch(actions.setErrors(model, errors));
        }
        else {
            dispatch(actions.resetErrors(model));
            dispatch(actions.reset("wirelessPortInBusinessFormA.termAgreement"))
        }
    }
    catch (e) {
        return;
    }
}

async function getPlanComponentByPlan(dispatch, planId){
    try {
        var res = await httpGet(`external/orderRequest/getInventoryPlanComponentByPlan/${planId}`);

        var dataItem = res.datatable[0].dataItem;
        var totalOrderCost = dataItem.length > 0 ? addZeroes(dataItem[0].TotalComponentCost) : 0;
        dispatch({
            type: getPlanComponent,
            plansDatatable: res.datatable,
            totalOrderCost: totalOrderCost
        });
    }
    catch (e) {
        dispatch({
            type: getPlanComponent,
            plansDatatable: [],
            totalOrderCost: 0
        });
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setFormSubmitting:
            return {
                ...state,
                formSubmitting: action.data
            };
        case getOrderRequestForm:
            return {
                ...state,
                orderRequest: action.orderRequest
            };
        case getPlanComponent:
            return {
                ...state,
                plansDatatable: action.plansDatatable,
                totalOrderCost: action.totalOrderCost
            };
        case getVendors:
            return {
                ...state,
                vendorOptions: action.vendorOptions
            };
        case getMobileServiceTypes:
            return {
                ...state,
                mobileServiceTypeOptions: action.mobileServiceTypeOptions
            };
        case getCircuitTypes:
            return {
                ...state,
                circuitTypeOptions: action.circuitTypeOptions
            };
        case setLoading:
            if (action.formName == "Subscription") {
                return {
                    ...state,
                    loadingSubscriptionForm: action.isLoading
                };
            }
            else {
                return {
                    ...state,
                    isLoading: action.isLoading
                };
            }
        case setUserLocation:
            return {
                ...state,
                userLocation: action.data
            };
        case setCountryOptions:
            return {
                ...state,
                countryOptions: action.data
            };
        case setAddressOptions:
            return {
                ...state,
                addressOptions: action.data
            };
        case setPlanOptions:
            return {
                ...state,
                planOptions: action.data
            };
        case setDeviceOptions:
            return {
                ...state,
                deviceOptions: action.data
            };
        case setDeviceAccessories:
            return {
                ...state,
                deviceAccessories: action.data
            };
        case setVendorDetails:
            return {
                ...state,
                vendorDetails: action.data
            };
        case setServiceTypeDetails:
            return {
                ...state,
                serviceTypeDetail: action.data
            };
        case setPrimaryPlanDetails:
            return {
                ...state,
                primaryPlanDetail: action.data
            };
        case setPurposeOfUseOptions:
            return {
                ...state,
                purposeOfUseOptions: action.data
            };
        case setBusinessCaseOptions:
            return {
                ...state,
                businessCaseOptions: action.data
            };
        case setShowDeviceOptions:
            return {
                ...state,
                showDeviceOptions: action.data
            };
        case setShowOtherAddress:
            return {
                ...state,
                showOtherAddress: action.data
            };
        case setFormSubmitted:
            return {
                ...state,
                formSubmitted: action.data
            };
        case setMobileError:
            return {
                ...state,
                mobileError: action.mobileError
            }
        default: return state;
    }
}